interface CommentItem {
  name: string;
  time: string;
  content: string;
  tag: string;
}

const comments: CommentItem[] = [
  {
    name: '追剧达人小明',
    time: '2小时前',
    content: '终于找到能流畅看《长安十二时辰》第二季的地方了！画质真的很不错，加载也快，推荐给身边的朋友了。',
    tag: '画质好评',
  },
  {
    name: '影迷小丸子',
    time: '5小时前',
    content: '这个站把香蕉视频、91视频和蜜桃视频的资源整合得很好，不用到处找了，而且没有广告弹窗，体验很棒。',
    tag: '资源齐全',
  },
  {
    name: '深夜追剧人',
    time: '8小时前',
    content: '移动端适配做得不错，躺床上用手机看也很流畅。就是希望纪录片版块能再多更新一些。',
    tag: '移动端友好',
  },
  {
    name: '电影发烧友老张',
    time: '12小时前',
    content: '《流浪地球3》超清版在这里看的，蓝光画质确实良心。更新速度也快，基本上热门的当天就能看到。',
    tag: '更新速度快',
  },
  {
    name: '综艺爱好者阿花',
    time: '1天前',
    content: '奔跑吧每期都追，这边更新同步很快。综艺版块要是能再多一点平台自制的内容就更完美了！',
    tag: '综艺专区',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            用户声音
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            听听真实用户的使用感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={comment.name}
              className={`bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/80 ${
                i === 0 ? 'md:col-span-3 md:max-w-2xl md:mx-auto' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-950 truncate">
                      {comment.name}
                    </span>
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}